import React, { useCallback, useRef, useEffect } from 'react';
import dynamic from 'next/dynamic';
import LinkGroup from './LinkGroup';
import { BottomText, FooterWrapper } from './styled';
import { Desktop, Mobile } from '../MediaQuery';
import { promotionsPolicy } from '../../helpers/routes';
import SocialGroup from './SocialGroup/SocialGroup';
import { useAppContext } from '../../store/appContext';
import { easeInOutQuint, scrollToY } from '../../helpers/animatedScrolling';
import { KlaviyoEmbedForm } from '../Klaviyo/KlaviyoEmbedForm';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';
import { NewsletterModalButton } from '../NewsletterModalButton/NewsletterModalButton';

const ItalistReadMore = dynamic(() =>
  import(/* webpackChunkName: "ItalistReadMore" */ '../ItalistReadMore/ItalistReadMore'),
);
const ItalistInfoBoxes = dynamic(() =>
  import(/* webpackChunkName: "ItalistReadMore" */ '../ItalistInfoBoxes/ItalistInfoBoxes'),
);

const Footer = ({ changeShippingVisibility }) => {
  const { localized } = useUrlBuilder();
  const klaviyoRef = useRef();
  const countrySelectionRef = useRef();
  const { country, footerData } = useAppContext();

  const showChangeShipping = useCallback(() => {
    scrollToY(0, 750, easeInOutQuint);
    setTimeout(() => changeShippingVisibility(), 150);
  }, [changeShippingVisibility]);

  useEffect(() => {
    const anchor = window.location.hash.substr(1);
    if (anchor === 'newsletter_subscribe') {
      scrollToY(klaviyoRef.current?.offsetTop, 1500, easeInOutQuint);
    }
    if (anchor === 'shipping_country') {
      scrollToY(countrySelectionRef.current?.offsetTop, 1500, easeInOutQuint);
    }
  }, []);

  return (
    <>
      <Mobile>
        <div ref={klaviyoRef}>
          <KlaviyoEmbedForm formId="klaviyo-embed-footer" />
        </div>
        <ItalistReadMore />
        <ItalistInfoBoxes />
        <FooterWrapper id="footer">
          <div style={{ padding: '0 2%' }}>
            <NewsletterModalButton />
          </div>
          <LinkGroup linkData={footerData} socialComp={<SocialGroup />} />
          <SocialGroup />
          <BottomText ref={countrySelectionRef} margin="5px auto 40px auto">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>You are shipping to</span>
              <span
                data-cy="footer-shipping-country-label"
                style={{ textDecoration: 'underline' }}
                onClick={changeShippingVisibility}>
                {country}
              </span>
            </div>
          </BottomText>
        </FooterWrapper>
      </Mobile>
      <Desktop>
        <ItalistReadMore />
        <ItalistInfoBoxes />
        <div ref={klaviyoRef}>
          <KlaviyoEmbedForm formId="klaviyo-embed-footer" paddingBottom="25px" />
        </div>
        <FooterWrapper id="footer">
          <LinkGroup linkData={footerData} socialComp={<SocialGroup />} />
          <BottomText margin="20px auto">
            *Please refer to our &nbsp;<a href={localized(promotionsPolicy)}>Promotions Policy</a>&nbsp; for further
            details.
          </BottomText>
          <BottomText ref={countrySelectionRef} margin="25px auto 5px auto">
            You are shipping to&nbsp;
            <span
              data-cy="footer-shipping-country-label"
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={showChangeShipping}
            >
              {country}
            </span>
          </BottomText>
          <BottomText margin="0 auto">italist Inc.</BottomText>
        </FooterWrapper>
      </Desktop>
    </>
  );
};

export default Footer;
